import React, { ReactNode } from "react";
import { Container } from "./styles";
import { useMediaQuery } from "@mui/material";

const Footer = ({
	children,
	className
}: {
	children: ReactNode | ReactNode[];
	className?: string;
	isPortrait?: boolean;
}) => {
	const isPortrait = useMediaQuery("(max-width:733px)");

	if (isPortrait && className === "") {
		return <Container>{children}</Container>;
	}
	return <>{children}</>;
};

export default Footer;
